import React from "react";
import { Typography, Breadcrumbs as MuiBreadCrumb } from "@material-ui/core";
import { Home, ChevronRight } from "@material-ui/icons";
import { Link } from "react-router";

export const Breadcrumbs = ({ breadcrumbs }) => {
    return (
        <MuiBreadCrumb
            separator={<ChevronRight style={{ fontSize: "14px" }} />}
            style={{ margin: "24px 0 24px 30px", fontSize: "14px" }}
        >
            <Link
                color="inherit"
                href="/"
                style={{ display: "flex", alignItems: "center", color: "#666666", gap: "8px" }}
            >
                <Home style={{ color: "#0A775A" }} />
                <Typography variant="subtitle2">Início</Typography>
            </Link>

            {breadcrumbs.map((item, i) => (
                <Link
                    key={i}
                    to={item.href}
                    style={{
                        color: "#666666",
                        pointerEvents: i + 1 === breadcrumbs.length ? "none" : "auto",
                    }}
                >
                    <Typography
                        variant="subtitle2"
                        color={i + 1 === breadcrumbs.length ? "primary" : "inherit"}
                    >
                        {item.label}
                    </Typography>
                </Link>
            ))}
        </MuiBreadCrumb>
    );
};
